const AbstractEntity = require('@/lib/Entities/AbstractEntity');
const { populate } = require('@/functions/objects');
const { toBool, toInt, toNullableString } = require('@/functions/transform');

class ReturnReason extends AbstractEntity {
    constructor(data = null) {
        super();

        this.description = '';
        this.returnToStock = null;

        if (data) {
            populate(this, data);
        }
    }

    getHydrationMap() {
        return {
            ID: {
                field: ['ID', 'reasonID'],
                transform: toInt,
            },
            description: {
                field: ['description', 'reasonDescription'],
                transform: toNullableString,
            },
            returnToStock: {
                field: ['returnToStock', 'defaultReturnToStock'],
                transform: toBool,
            },
        };
    }
}

module.exports = ReturnReason;
